import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconOrders = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 107.84 123.66571">
    <path fill={theme.palette.primary.A100} d="m10.499-0.0004959-10.499 40.028h97.338l10.502-40.028h-97.341z" />
    <path fill={theme.palette.primary.A400} d="m0 40 7.8262 40.028h98.215l-8.698-40.028h-97.342z" />
    <g fill={theme.palette.primary.A100}>
      <path d="m87.689 51.638h-72.914l-0.775-3.6389h72.804l0.885 3.6389z" />
      <path d="m87.892 60.638h-71.135l-0.757-3.6389h71.135l0.757 3.6389z" />
      <path d="m91.689 71.638h-72.804l-0.885-3.6389h72.804l0.885 3.6389z" />
      <path d="m7.8841 80-6.8841 38.54l5.0652 5.1307 6.4471-5.3491 4.3704 5.3491 6.4473-5.3491 4.48 5.3491 6.4468-5.3491 4.3708 5.3491 6.4467-5.3491 4.4801 5.3491 6.3375-5.3491 4.4801 5.3491 6.4472-5.3491 4.48 5.3491 6.3376-5.3491 4.48 5.3491 6.4469-5.3491 4.48 5.3491 6.01-5.131 6.996-38.536h-98.166z" />
    </g>
    <g fill={theme.palette.grey[100]}>
      <path d="m91.135 91.638h-71.135l0.75695-3.6389h71.135l-0.757 3.6389z" />
      <path d="m89.243 100.64h-71.243l0.75682-3.6389h71.135l-0.649 3.6389z" />
      <path d="m51.176 111.64h-35.176l0.65947-3.6389h35.287l-0.77 3.6389z" />
      <path d="m92.026 11.638h-51.026l1.0951-3.6389h51.027l-1.096 3.6389z" />
      <path d="m89.024 22.638h-51.024l1.0974-3.6389h51.025l-1.098 3.6389z" />
      <path d="m87.027 31.638h-51.027l1.0948-3.6389h51.027l-1.095 3.6389z" />
      <path d="m24.78 25.018c0.826-3.294-1.0318-5.929-4.0251-5.929-1.3418 0-2.0643-1.0978-1.7546-2.5251 0.3096-1.4272 1.6514-2.5253 2.9933-2.5253 0.61909 0 1.2386 0.32927 1.5482 0.76861 0.4128 0.6587 1.4452 0.6587 2.1672 0.1099 0.826-0.6586 1.136-1.6469 0.62-2.4155-0.516-0.7688-1.239-1.3176-2.065-1.6469l0.31-1.2078c0.206-0.87843-0.31-1.6469-1.1354-1.6469-0.8259 0-1.7547 0.76875-1.961 1.6469l-0.31 1.2068c-2.4772 0.7687-4.6447 2.9643-5.3674 5.5994-0.82578 3.2939 1.0323 5.9289 4.0255 5.9289 1.3419 0 2.0642 1.098 1.7547 2.5253-0.30968 1.4274-1.6515 2.5254-2.9933 2.5254-0.61922 0-1.2387-0.3294-1.5482-0.7687-0.41277-0.6587-1.445-0.6587-2.1677-0.1098-0.8258 0.6586-1.1355 1.6468-0.61909 2.4156 0.51586 0.7686 1.2386 1.3175 2.0641 1.6467l-0.30955 1.2078c-0.20645 0.8786 0.30955 1.6469 1.1355 1.6469 0.8258 0 1.7546-0.7687 1.961-1.6469l0.3096-1.208c2.4773-0.6589 4.7481-2.9643 5.3673-5.5994z" />
    </g>
  </SvgIcon>
);

IconOrders.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconOrders);



// WEBPACK FOOTER //
// ./src/components/icons/IconOrders.js